/**
 * axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import store from './vuex/store'
import Toast from './muse-ui-plugin/muse-ui-toast'

// 环境的切换
//本地 国外
// axios.defaults.baseURL =  'http://139.129.226.213:8020/mdm';
// axios.defaults.baseURL =  'http://139.129.226.213:8021/mdm';
// axios.defaults.baseURL =  'http://62.234.1.152:8020/mdm';
//axios.defaults.baseURL =  'http://62.234.1.152:8030/mdmEn';
// axios.defaults.baseURL =  'http://' + window.location.hostname + '  :8020/mdm';
// axios.defaults.baseURL =  'http://192.168.31.254:8020/mdm';
// axios.defaults.baseURL =  'http://52.57.219.36:8020/mdm/'
//国内
// axios.defaults.baseURL =  'https://mdm.cilico.cn/mdmserver';
//axios.defaults.baseURL =  'http://127.0.0.1:8020/mdm';
axios.defaults.baseURL =  '/mdmserver';

// 请求超时时间
axios.defaults.timeout = 3600000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.defaults.withCredentials = true
// 请求拦截器
axios.interceptors.request.use(
    config => {

        // window.config.forEach(element => {
        //     if(element.port == window.location.port){
        //         axios.defaults.baseURL = element.servicePort;
        //     }
        // });

        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        const token = store.state.token;
        if (token) {
            config.headers.token = token;
        } else {
            config.headers.token = "";
        }
        // 多语言环境切换
        const lang = store.state.lang;
        if (lang) {
            config.headers.lang = lang;
        } else {
            config.headers.lang = "zh-CN";
        }
        return config;
    },
    error => {
        console.log("interceptors.request error:" + error);
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {

        if (response.status === 200) {
           // store.commit("set_token",response.headers.token)
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        if (error && error.response && error.response.status) {
            console.log("response error code:" + error.response.status);
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    if(store.state.lang == 'zh-CN' || store.state.lang == 'zh'){
                        Toast.error({
                            message: '用户未登陆',
                            time: 1600,
                            close: true
                        });
                    }else{
                        Toast.error({
                            message: 'User not logged in',
                            time: 1600,
                            close: true
                        });
                    }

                    setTimeout(() => {
                        // router.replace({
                        //     path: '/',
                        //     query: { redirect: router.currentRoute.fullPath }
                        //   })
                        location.href = "/";
                    }, 1200);
                    break;
                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 403:
                    if(store.state.lang == 'zh-CN' || store.state.lang == 'zh'){
                        Toast.error({
                            message: '登录过期，请重新登录',
                            time: 1600,
                            close: true
                        });
                    }else{
                        Toast.error({
                            message: 'Login expired, please login again',
                            time: 1600,
                            close: true
                        });
                    }

                    // 清除token
                    localStorage.removeItem('token');
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => {
                        // router.replace({
                        //     path: '/login'
                        // });
                        location.href = "/mdm/login";
                    }, 1000);
                    break;
                // 404请求不存在
                case 404:
                    if(store.state.lang == 'zh-CN' || store.state.lang == 'zh'){
                        Toast.error({
                            message: '网络请求不存在',
                            time: 15000,
                            close: true
                        });
                    }else{
                        Toast.error({
                            message: 'The network request does not exist',
                            time: 15000,
                            close: true
                        });
                    }

                break;
                // 其他错误，直接抛出错误提示
                default:
                    Toast.error({
                        message: error.response.data.message,
                        time: 1500,
                        close: true
                    });
            }
            return Promise.reject(error.response);
        }else{
            console.log(error);
        }
    }
);
export function getUrl() {
    return axios.defaults.baseURL;
}
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params){
    const lang = store.state.lang;
    if (lang) {
        url += '?lang=' + lang;
    } else {
        url += '?lang=' + navigator.language;
    }
    if (params == null) {
        params = {};
    }
    if (window.ActiveXObject || 'ActiveXObject' in window) {
        params.timestamp = new Date().getTime();
    }
    return new Promise((resolve, reject) =>{

        axios.get(url, {
            params: params
        })
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {

    const lang = store.state.lang;
    if (lang) {
        url += '?lang=' + lang;
    } else {
        url += '?lang=' + navigator.language;
    }
    return new Promise((resolve, reject) => {
        axios.post(url, params)
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}

export function patch(url, params) {

    const lang = store.state.lang;
    if (lang) {
        url += '?lang=' + lang;
    } else {
        url += '?lang=' + navigator.language;
    }
    return new Promise((resolve, reject) => {
        axios.patch(url, params)
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}

export function delet(url, data) {

    const lang = store.state.lang;
    if (lang) {
        url += '?lang=' + lang;
    } else {
        url += '?lang=' + navigator.language;
    }
    return new Promise((resolve, reject) => {
        axios.delete(url, {
            data: data
        })
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    });
}


// WEBPACK FOOTER //
// ./src/axios.js